var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInduction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.551,
    height: 62.548,
    viewBox: "0 0 62.551 62.548",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(0.75 0.785)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-71",
    d: "M27,27,5.784,21.216,0,0,21.216,5.784Z",
    transform: "translate(17 17)",
    fill: "none",
    stroke: "#eb742e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-72",
    d: "M0,30.5A30.5,30.5,0,1,1,8.932,52.066,30.5,30.5,0,0,1,0,30.5Z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInduction);
export default __webpack_public_path__ + "static/media/induction.3d35d17cc142069c7c260715f42eb47d.svg";
export { ForwardRef as ReactComponent };